export default function preventOrphan( string ){
    return string.replace(/\s(\S+)$/,"&nbsp;$1")
};